import { isPlatformBrowser, NgClass } from '@angular/common';
import { Component, inject, OnInit, PLATFORM_ID } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms'
import { RouterLink } from '@angular/router';
import { AuthService } from '../../service/auth-service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Analytics, logEvent } from '@angular/fire/analytics';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
@Component({
  selector: 'app-login',
  imports: [FormsModule, RouterLink, ReactiveFormsModule, FontAwesomeModule],
  templateUrl: './login.html',
  styleUrl: './login.scss'
})
export class Login implements OnInit{
  protected loading = false;
  protected signInForm: FormGroup
  private authService = inject(AuthService)
  private snackBar = inject(MatSnackBar)
  private analytics = inject(Analytics);
  private platformId = inject(PLATFORM_ID);
  hideSignInPassword = true;
  faEye=faEye
  faEyeSlash=faEyeSlash

  constructor() {
    this.signInForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
      password: new FormControl('', [Validators.required])
    })
  }

  ngOnInit() {
    if(isPlatformBrowser(this.platformId)){
      logEvent(this.analytics, 'login_page_view', { page_path: '/sign-in' });
    }
  }

  onSubmit() {
    this.loading = true
    const email = this.signInForm.value.email;
    const password = this.signInForm.value.password;
    this.authService.emailLogin(email, password).subscribe({
      next: () => {
        this.loading = false
        this.snackBar.open('Login successful!', 'Close', { duration: 5000 });
      },
      error: (err) => {
        this.loading = false
        this.snackBar.open("Login Error!", 'Close', { duration: 5000 });
        console.log(err)
      },
      complete: () => {
        this.loading = false
      }
    })
  }

  signInWithGoogle() {
    this.authService.googleLogin().subscribe({
      next: () => {
        this.loading = false
        this.snackBar.open('Google sign-in successful!', 'Close', { duration: 5000 });
      },
      error: (err) => {
        this.loading = false
        this.snackBar.open("Login Error!", 'Close', { duration: 5000 });
        console.log(err)
      },
      complete: () => {
        this.loading = false
      }
    });
  }
}
